import { useMemo } from "react"
import { AuthUser } from "@/model/authUser"

export const useAuthUser = (token: string): AuthUser => {
    return useMemo(() => JSON.parse(atob(token.split(".")[1])), [token])
}
